<template>
  <div class="driver-wallet-settings">
    <div class="background" @click="close" />

    <div style="position: relative">
      <button class="delete is-large is-pulled-right" @click="close" />
      <p class="subtitle">{{ $t("driver.driver-settings") }}</p>

      <p class="label">{{ $t("driver.box-size") }}</p>
      <p class="is-flex">
        <span class="tag" :class="boxSize === 'none' ? 'is-danger' : 'is-dark'" @click="setBoxSize('none')">{{
          $t("driver.no-box") }}</span>
        <span class="tag" :class="boxSize === 'small' ? 'is-warning' : 'is-dark'" @click="setBoxSize('small')">{{
          $t("driver.small-box") }}</span>
        <span class="tag" :class="boxSize === 'large' ? 'is-success' : 'is-dark'" @click="setBoxSize('large')">{{
          $t("driver.large-box") }}&nbsp;<i class="fa fa-pizza-slice fa-sm" />
        </span>
      </p>

      <div style="height: 20px" />

      <p class="label">{{ $t("driver.passengers") }}</p>
      <p class="is-flex">
        <!-- <span /> -->
        <span class="tag" :class="acceptPassengers === 'no' ? 'is-danger' : 'is-dark'"
          @click="setAcceptPassengers('no')">{{ $t("no") }}&nbsp;
          <i class="fa fa-user-slash" />
        </span>
        <span class="tag" :class="acceptPassengers === 'yes' ? 'is-success' : 'is-dark'"
          @click="setAcceptPassengers('yes')">{{ $t("yes") }}&nbsp;
          <i class="fa fa-user" />
        </span>
      </p>

      <div style="height: 20px" />
      <p class="label">{{ $t("driver.max-distance") }}</p>
      <p class="is-flex">
        <!-- <span /> -->
        <span class="tag" :class="maxDistance === 'short' ? 'is-danger' : 'is-dark'" @click="setMaxDistance('short')">{{
          $t("driver.short") }} &lt;10km</span>
        <span class="tag" :class="maxDistance === 'long' ? 'is-success' : 'is-dark'" @click="setMaxDistance('long')">{{
          $t("driver.long") }} >10km</span>
      </p>

      <div style="height: 20px" />

      <p class="label">{{ $t("driver.max-purchase") }}</p>
      <p class="is-flex">
        <span class="tag" :class="maxPurchase === 1000 ? 'is-danger' : 'is-dark'"
          @click="setMaxPurchase(1000)">&lt;1k</span>
        <span class="tag" :class="maxPurchase === 2000 ? 'is-warning' : 'is-dark'"
          @click="setMaxPurchase(2000)">1k-2k</span>
        <span class="tag" :class="maxPurchase === 6000 ? 'is-success' : 'is-dark'" @click="setMaxPurchase(6000)">2k+
        </span>
      </p>

      <div style="height: 20px" />

      <!-- <p class="label">{{ $t("driver.accept-button") }}</p>
      <p class="is-flex">
        <span class="tag" :class="acceptButton === 'new' ? 'is-success' : 'is-dark'" @click="setAcceptButton('new')">{{
          $t("new-style") }}</span>
        <span class="tag" :class="acceptButton === 'legacy' ? 'is-danger' : 'is-dark'"
          @click="setAcceptButton('legacy')">{{
            $t("old-style") }}</span>
      </p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "DriverWalletSettings",
  data() {
    return {
      acceptButton: "new",
      maxPurchase: 0,
      maxDistance: "long",
      boxSize: "none",
      acceptPassengers: "no",
      roleData: null,
    };
  },
  computed: {
    role() {
      return this.$store.getters.getDriverRole;
    },
  },
  mounted() {
    this.roleData = this.role.data;
    this.maxDistance = this.roleData.max_distance;
    this.boxSize = this.roleData.box_size;
    this.acceptPassengers = this.roleData.accept_passengers;
    this.maxPurchase = this.roleData.max_purchase;
    this.acceptButton = this.roleData.accept_button;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    setAcceptButton(style) {
      this.acceptButton = style
      this.roleData.accept_button = style;
      this.updateDriverRoleData();
    },
    setMaxDistance(state) {
      this.maxDistance = state;
      this.roleData.max_distance = state;
      this.updateDriverRoleData();
    },
    setMaxPurchase(amount) {
      this.maxPurchase = amount;
      this.roleData.max_purchase = amount;
      this.updateDriverRoleData();
    },
    setAcceptPassengers(state) {
      this.acceptPassengers = state;
      this.roleData.accept_passengers = state;
      this.updateDriverRoleData();
    },
    setBoxSize(state) {
      this.boxSize = state;
      this.roleData.box_size = state;
      this.updateDriverRoleData();
    },
    updateDriverRoleData() {
      var payload = {
        id: this.role.id,
        data: this.roleData,
      };
      this.console("updateRole", payload);
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateRoleData", payload)
        .then((res) => {
          console.log("updateRoleData", res);
          this.updateRoles(true);
        })
        .catch((err) => console.error("updateRoleData", err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.driver-wallet-settings {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 10px;
  background-color: #1f1b24;
  color: white;
  padding-bottom: 30px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  text-align: left;
  box-shadow: 0px 0px 4px 4px white;
}

.subtitle {
  font-size: 1.3em;
  margin-bottom: 18px;
  margin-top: 10px;
  color: #999;
}

.list {
  background-color: black;
  margin-top: 6px;
}

.list-item {
  color: white;
  border-bottom: 1px solid #333;
  padding: 4px 6px;
}

.is-flex {
  justify-content: space-between;
  gap: 4px;
}

.is-flex span {
  flex: 1;
}

.tag {
  font-weight: 500;
  padding: 4px;
  font-size: 0.85em;
}

.label {
  color: #bbb;
  margin-bottom: 4px;
}

.background {
  background-color: rgba(0, 0, 0, 0.4);
  height: 100vh;
  width: 100vw;
  position: absolute;
  bottom: 0;
  left: 0;
  /* backdrop-filter: blur(2px); */
}

p .tag {
  font-size: 0.9em;
}

.is-success {
  color: black;
}
</style>